<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="white"
    />
    <path
      d="M26 22C26 22.3536 25.8595 22.6928 25.6095 22.9428C25.3594 23.1929 25.0203 23.3333 24.6667 23.3333H16.6667L14 26V15.3333C14 14.9797 14.1405 14.6406 14.3905 14.3905C14.6406 14.1405 14.9797 14 15.3333 14H24.6667C25.0203 14 25.3594 14.1405 25.6095 14.3905C25.8595 14.6406 26 14.9797 26 15.3333V22Z"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
